function a(r) {
  return Array.isArray(r);
}
export {
  a as i
};
//# sourceMappingURL=isArray-QlWcxgml.mjs.map
